const handlePaymentThatRequiresCustomerAction = ({   stripe,
                                                     subscription,
                                                     invoice,
                                                     priceId,
                                                     paymentMethodId,
                                                     isRetry
                                                 }) => {

    
    if (subscription && subscription.status === 'active' || subscription && subscription.status === 'trialing') {
        // Subscription is active, no customer actions required.
        return { subscription, priceId, paymentMethodId };
    }

    const {latest_invoice = {}} = subscription

    // If it's a first payment attempt, the payment intent is on the subscription latest invoice.
    // If it's a retry, the payment intent will be on the invoice itself.
    const paymentIntent = invoice ? invoice.payment_intent : latest_invoice.payment_intent;

    const actions = ['requires_action', 'requires_confirmation'];
    if (actions.includes(paymentIntent.status) || (isRetry === true && paymentIntent.status === 'requires_payment_method')) {


        return stripe
            .confirmCardPayment(paymentIntent.client_secret, {
                payment_method: paymentMethodId
            })
            .then((result) => {
                if (result.error) {


                    // Start code flow to handle updating the payment details.
                    // Display error message in your UI.
                    // The card was declined (i.e. insufficient funds, card has expired, etc).
                    throw result;
                } else {
                    if (result.paymentIntent.status === 'succeeded') {
                        // Show a success message to your customer.
                        return {
                            priceId: priceId,
                            subscription: subscription,
                            invoice: invoice,
                            paymentMethodId: paymentMethodId,
                        };
                    }
                }
            })
            .catch((error) => {
                errorCallback(error)

            });
    } else {
        // No customer action needed.
        return { subscription, priceId, paymentMethodId };
    }
}

const handleRequiresPaymentMethod = ({
    subscription,
    paymentMethodId,
    priceId
}) => {

    if (subscription.status === 'active' || subscription && subscription.status === 'trialing') {
        // subscription is active, no customer actions required.
        return { subscription, priceId, paymentMethodId };
    } else if (subscription.latest_invoice.payment_intent.status === 'requires_payment_method') {
        // Using localStorage to manage the state of the retry here,
        // feel free to replace with what you prefer.
        // Store the latest invoice ID and status.
        localStorage.setItem('latestInvoiceId', subscription.latest_invoice.id);
        localStorage.setItem(
            'latestInvoicePaymentIntentStatus',
            subscription.latest_invoice.payment_intent.status
        );
        throw { error: { message: 'Your card was declined.' } };
    } else {
        return { subscription, priceId, paymentMethodId };
    }
}

// Предоставить изначальный доступ пользователю
const handleSuccessPayment = ({
    subscription
}) => {
    const formData = new FormData()

    formData.append('subscription', JSON.stringify(subscription));
    formData.append('action', 'get_access');

    return (
        fetch(`/payment`, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        })
            .then((response) => {
                return response.json();
            })
            .then(result => {
                return result
            })
    )
}

export const createSubscription = ({ stripe, paymentMethod, priceId, errorCallback, successCallback }) => {

    const formData = new FormData();

    formData.append('paymentMethod', JSON.stringify(paymentMethod));
    formData.append('priceId', priceId);

    return (
            fetch(`/payment`, {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
            })
            .then((response) => {
                return response.json();
            })
            // If the card is declined, display an error to the user.
            .then((result) => {
                if (result.error) {
                    errorCallback(result.error)

                    // The card had an error when trying to attach it to a customer.
                    throw result;
                }

                return result;
            })
            // Normalize the result to contain the object returned by Stripe.
            // Add the additional details we need.
            .then((result) => {
                return {
                    stripe,
                    paymentMethodId: paymentMethod.id,
                    priceId: priceId,
                    subscription: result.subscription,
                };
            })
            // Some payment methods require a customer to be on session
            // to complete the payment process. Check the status of the
            // payment intent to handle these actions.
            .then(handlePaymentThatRequiresCustomerAction)
            // If attaching this card to a Customer object succeeds,
            // but attempts to charge the customer fail, you
            // get a requires_payment_method error.
            .then(handleRequiresPaymentMethod)
            // No more actions required. Provision your service for the user.
            .then(handleSuccessPayment)
            .then((result) => {


                
                if (result.success === true) {

                    successCallback()

                    // const getPath = this.props.app.getPath
                    // this.props.app.history.push(getPath('/done'))

                } else {

                    errorCallback()
                    console.log('Ошибка');


                }

            })
            .catch((error) => {

                errorCallback()
                console.log(error);
                // An error has happened. Display the failure to the user here.
                // We utilize the HTML element we created.
                //showCardError(error);
            })
    );
}
